const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/course-comments/$chatRoomUuid.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/settings/inbox/course-comments/$chatRoomUuid")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});